export const MCP_ROUTE = '/dashboard/api/mcp';
export const MCP_SERVER_URL =
  'https://www.bumper.com/ms/ltvco-prod-apis-mcp-server/mcp/reports';
export const MCP_OAUTH_CLIENT_ID = 'claude-mcp';
export const CLAUDE_CONNECTORS_URL = 'https://claude.ai/customize';

export type McpClient = 'claude' | 'chatgpt' | 'agent';

export const MCP_CLIENTS: {
  id: McpClient;
  label: string;
  available: boolean;
}[] = [
  { id: 'claude', label: 'Claude', available: true },
  { id: 'chatgpt', label: 'ChatGPT', available: false },
  { id: 'agent', label: 'Agent', available: false },
];

export const ASSISTANT_CAPABILITIES = [
  'Look up vehicle history reports by VIN, plate, or year/make/model (read-only).',
  'Pull accident history, title status, market value, and safety data on your behalf.',
  "Nothing else. It can't change your account, see billing info, or reach other services.",
];
